'use client';

import CategorySelected from 'app/components/category/products/CategorySelected';
import OpenFilterButton from 'app/components/category/products/OpenFilterButton';
import CategoryOrdering from 'app/components/category/CategoryOrdering';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import ProductCard from 'app/components/product/card/ProductCard';
import Infinite from 'app/components/category/infinite/Infinite';
import Pagination from 'app/components/category/pagination/Pagination';
import toNumber from 'lodash/toNumber';
import useSWR from 'swr';
import { useStaticSearchParams } from 'utils/useStaticSearchParams';
import ProductsLoading from './ProductsLoading';
import MicroData, { MICRODATA_ITEM_LIST } from '@/grandus-lib/components-atomic/MicroData';
import CategoryAnalytics from '@/app/components/category/CategoryAnalytics';

const ProductsActiveFilters = ({ category, filterParams }) => {
  return (
    <CategorySelected
      category={category}
      isDesktop={true}
      filterParams={filterParams}
    />
  );
};

const Products = ({
  parameters,
  category,
  breadcrumbs,
  params,
  handleOrderingLinkAttributes,
  handlePaginationLinkAttributes,
  handleGetData,
  hidePerPage = false,
  filterParams
}) => {
  const searchParams = useStaticSearchParams();

  const localSearchParams = Object.fromEntries(searchParams.entries());

  if (isEmpty(params?.parameters) && isEmpty(params?.term)) {
    params.parameters = ['hlavny-produkt', 1];
  }

  const props = { params: params, searchParams: localSearchParams };

  const url = `/api/product?props=${encodeURIComponent(JSON.stringify(props))}`;

  const { data, isLoading } = useSWR(
    url,
    url => fetch(url).then(r => r.json()),
    {
      revalidateOnReconnect: false,
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    },
  );

  const products = data?.products;
  const pagination = data?.pagination;

  const categorySlimmed = { url_key: category?.urlName, id: category?.id };

  if (isEmpty(products) && isLoading) {
    return <ProductsLoading />;
  }

  return (
    <>
      <div className={'flex items-center gap-4 mb-4'}>
        <div className={'basis-full'}>
          <div className={'lg:hidden'}>
            <OpenFilterButton params={params} />
          </div>
        </div>

        <div className="basis-auto text-end w-full lg:w-auto">
          <CategoryOrdering
            parameters={parameters}
            category={category?.urlName}
            handleLinkAttributes={handleOrderingLinkAttributes}
          />
        </div>
      </div>

      <div className={'mb-4 lg:mb-8'}>
        <ProductsActiveFilters
          category={categorySlimmed}
          filterParams={filterParams}/>
      </div>

      <div
        id="products-list"
        className={'grid grid-cols-1 md:grid-cols-3 py-4 gap-4 md:gap-6'}
      >
        <MicroData
          data={{ products, totalNumberOfItems: pagination?.totalCount }}
          type={MICRODATA_ITEM_LIST}
        />
        <CategoryAnalytics products={products} category={category}/>
        {map(products ? products : [], (product, index) => {
          return (
            <div key={`product-${product?.id}-${index}`} className={'col'}>
              <ProductCard product={product} />
            </div>
          );
        })}
      </div>

      {pagination?.pageCount > 1 &&
      pagination?.currentPage !== pagination?.pageCount ? (
        <Infinite
          productClassName={''}
          {...pagination}
          destinationElementId={'products-list'}
          category={category}
          data={props}
          url={url}
        />
      ) : (
        ''
      )}

      <div className={'mt-8 mb-8'}>
        {pagination?.pageCount > 1 ? (
          <Pagination
            {...pagination}
            currentPage={toNumber(localSearchParams?.page) || 1}
            parameters={parameters}
            searchParams={localSearchParams}
            category={category?.urlName}
            handleLinkAttributes={handlePaginationLinkAttributes}
          />
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export default Products;
